import { DragDropRejected } from '@lib/files/drag-files';
import { useDragDropUpload as useDragDropUploadLib } from '@lib/hooks/useDragDropUpload';

export const useDragDropUpload = (
  onFilesDropped?: (files: File[], rejected: DragDropRejected[]) => void,
) => {
  const { isDragging } = useDragDropUploadLib(
    true, // Enable mouse leave handler
    undefined, // onDragEnter - not needed
    undefined, // onDragLeave - not needed
    undefined, // onDrop - not needed
    onFilesDropped,
  );

  return {
    isDragging,
  };
};
